module.exports = __webpack_public_path__ + "static/media/q_of_diamonds2.29dcbaa2.png";